const images = {
  logo: require('./logo-light.png'),
}

export default images;



// WEBPACK FOOTER //
// ./src/images/index.js